import { Box, Drawer, styled, Tab, Theme, Toolbar } from '@mui/material';
import { Link } from 'react-router-dom';

export const CustomTab = styled(Tab)(({ theme }) => ({
  alignItems: 'baseline',
  color: theme.palette.gray.mediumDark,
  display: 'flex',
  fontSize: theme.typography.body2.fontSize,
  fontWeight: theme.typography.fontWeightMediumBold,
  paddingBottom: theme.spacing(1),
  paddingLeft: theme.spacing(1.5),
  paddingTop: theme.spacing(1),
  width: '100%',
}));

export const DesktopCandidatesLink = styled(Link)(({ theme }) => ({
  alignItems: 'center',
  color: theme.palette.gray.mediumDark,
  display: 'flex',
  fontWeight: theme.typography.fontWeightMediumBold,
  justifyContent: 'flex-start',
  minHeight: theme.spacing(6),
  padding: `${theme.spacing(1)} ${theme.spacing(1.5)}`,
  width: '100%',
  boxSizing: 'border-box',
  textDecoration: 'none',
  '&:hover': {
    color: theme.palette.gray.mediumDark,
  },
}));

export const DrawerHeader = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
}));

export const MobileCandidatesLink = styled(Link)(({ theme }) => ({
  alignItems: 'center',
  color: theme.palette.text.primary,
  display: 'flex',
  justifyContent: 'unset',
  padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
  width: '100%',
  '&:hover': {
    color: `${theme.palette.text.primary} !important`,
  },
}));

export const MobileToolbar = styled(Toolbar)(({ theme }) => ({
  width: '100%',
  borderBottom: `1px solid ${theme.palette.border.main}`,
  paddingBottom: theme.spacing(2),
  marginBottom: theme.spacing(3),
}));

export const TabDrawer = styled(Drawer)(() => ({
  width: '100%',
  '.MuiPaper-root': {
    width: '80%',
  },
}));

export const tabsSx = (theme: Theme) => ({
  width: '20%',
  '.MuiTabs-flexContainer': {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    '& > *': {
      width: '100%',
      flexShrink: 0,
    },
  },
  '& .MuiTabs-indicator': {
    width: 4,
  },
  '& .MuiTab-root': {
    alignItems: 'flex-start',
    textAlign: 'left',
    justifyContent: 'flex-start',
    width: '100%',
  },
  '& .MuiTab-root.Mui-selected': {
    backgroundColor: theme.palette.primary.fill,
    width: '100%',
  },
  '& .MuiTabs-scroller': {
    display: 'flex',
    alignItems: 'flex-start',
    width: '100%',
  },
});

export const ToolbarHeader = styled(Box)(() => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}));
